import { Title } from "rizzui";
import { IEnquiryEntry } from "@/utilities/types/EnquiryEntry";
import { ITrackingTimeline } from "@/utilities/types/TrackingTimeline";
import isValidJson from "@/utils/is-valid-json";
import ImprovedTimeline from "@/components/timeline/ImprovedTimeline";

interface LeadAcquisitionAndScoreProps {
  data?: IEnquiryEntry;
}

export default function LeadAcquisitionAndScore({
  data,
}: LeadAcquisitionAndScoreProps) {
  const timelineData =
    typeof data?.tracking === "string" && isValidJson(data.tracking)
      ? JSON.parse(data.tracking)
      : ({} as ITrackingTimeline);

  return (
    <div
      className={
        "flex flex-col justify-center items-center md:flex md:flex-wrap w-full"
      }
    >
      <div className="w-full flex items-center justify-start">
        <Title as="h3" className="mb-5 font-lexend  font-medium text-lg">
          How was this lead acquired?
        </Title>
      </div>
      <ImprovedTimeline
        submittedFromDomain={data?.submittedFromDomain || ""}
        timelineData={timelineData}
      />
    </div>
  );
}
